import { render } from "./ProductImportModal.vue?vue&type=template&id=2b6b7933"
import script from "./ProductImportModal.vue?vue&type=script&lang=js"
export * from "./ProductImportModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__